import { Component, ViewEncapsulation } from "@angular/core";
@Component({
  selector: "quick-chat",
  templateUrl: "./quick-chat.component.html",
  styleUrls: ["./quick-chat.component.scss"],
  encapsulation: ViewEncapsulation.None,
  exportAs: "quickChat",
  standalone: true,
  imports: [],
})
export class QuickChatComponent {}
